import { cx, Text } from '@vtex/admin-ui'
import { FormState, getErrorText } from '@vtex/admin-ui-form'
import { DefaultProps } from 'typings'
import { useFormStateContext } from '../../../providers'
import styles from './styles'
import { useMemo } from 'react'

type ErrorBoxProps = {
  name: string
  withBorder?: boolean
  state?: FormState
  className?: string
}

type ChildrenRenderProps = {
  withBorder: boolean
}

const ChildrenRender = (props: ChildrenRenderProps & DefaultProps) => {
  const { children, withBorder } = props

  return withBorder ? (
    <div className={cx(styles.content)} data-pp-border>
      {children}
    </div>
  ) : (
    children
  )
}

export function FieldGroupBox(props: ErrorBoxProps & DefaultProps) {
  const {
    name,
    children,
    withBorder = true,
    state,
    className: customClassName = '',
  } = props
  const { form: mainForm } = useFormStateContext()

  const form = useMemo(() => state ?? mainForm, [state, mainForm])

  const errorMessage = getErrorText(form, name)

  return (
    <div
      className={cx(
        styles.container,
        errorMessage ? 'critical' : 'neutral',
        customClassName
      )}
    >
      <ChildrenRender withBorder={withBorder}>{children}</ChildrenRender>
      <Text variant="detail" tone="critical" className={styles.errorMessage}>
        {errorMessage}
      </Text>
    </div>
  )
}
